import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-640b5b9c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "loyalty" }
const _hoisted_2 = { class: "loyalty__balance balance" }
const _hoisted_3 = { class: "balance__title-block" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "balance__left-title" }, "Бонусный баланс", -1))
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "balance__list" }
const _hoisted_7 = { class: "balance__item balance-item" }
const _hoisted_8 = { class: "balance-item__title-block" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "balance-item__icon" }, null, -1))
const _hoisted_10 = { class: "balance-item__title" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "balance-item__description" }, "Бонусы за заказы", -1))
const _hoisted_12 = {
  key: 0,
  class: "balance-item__burning-scores"
}
const _hoisted_13 = { class: "loyalty__cashback cashback" }
const _hoisted_14 = { class: "cashback__title" }
const _hoisted_15 = { class: "cashback__title--percent" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cashback__description" }, " Делайте заказы на доставку или забирайте с собой, мы начислим Вам бонусы после выполнения заказа ", -1))
const _hoisted_17 = {
  key: 0,
  class: "cashback__levels levels"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "levels__title" }, "Ваш кешбэк", -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = {
  key: 2,
  class: "cashback__to-next-level"
}
const _hoisted_21 = { class: "medium" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cashback__line" }, null, -1))
const _hoisted_23 = {
  key: 0,
  class: "loyalty__history history"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "history__title" }, "История операций", -1))
const _hoisted_25 = { class: "history__filters filters" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "history__mobile-filters filters" }
const _hoisted_28 = {
  key: 1,
  class: "history__not-bonuses"
}
const _hoisted_29 = {
  key: 2,
  class: "history__actions"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LevelsList = _resolveComponent("LevelsList")!
  const _component_SortingPanel = _resolveComponent("SortingPanel")!
  const _component_HistoryScores = _resolveComponent("HistoryScores")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (_ctx.companyStore.documentsUrls[_ctx.DOCUMENT_TYPE.LOYALTY_PROGRAM_RULES])
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: _ctx.companyStore.documentsUrls[_ctx.DOCUMENT_TYPE.LOYALTY_PROGRAM_RULES],
              target: "_blank",
              class: "balance__right-title"
            }, " Правила программы лояльности ", 8, _hoisted_5))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.authStore.bonusInfo.balance) + " ББ", 1)
          ]),
          _hoisted_11,
          (_ctx.authStore.bonusInfo.burningDate)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, " Ближайшее сгорание: " + _toDisplayString(_ctx.authStore.bonusInfo.burningDate), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createTextVNode(" Ваш кешбэк составляет "),
        _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.authStore.bonusInfo.percent) + "%", 1)
      ]),
      _hoisted_16,
      (_ctx.authStore.bonusInfo.levels)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19))
        : _createCommentVNode("", true),
      (_ctx.authStore.bonusInfo.levels)
        ? (_openBlock(), _createBlock(_component_LevelsList, {
            key: 1,
            class: "cashback__levels-list",
            items: _ctx.authStore.bonusInfo.levels
          }, null, 8, ["items"]))
        : _createCommentVNode("", true),
      (_ctx.authStore.bonusInfo.remainingToNext)
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _createTextVNode(" До следующего уровня Вам осталось потратить "),
            _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.authStore.bonusInfo.remainingToNext) + " Р ", 1)
          ]))
        : _createCommentVNode("", true),
      _hoisted_22
    ]),
    (_ctx.historyScores)
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _hoisted_24,
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_25, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.FILTERS, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.value,
                  class: _normalizeClass({
              filters__item: true,
              'filters__item--active': _ctx.selectedFilter === item.value,
            }),
                  onClick: ($event: any) => (_ctx.selectFilter(item.value))
                }, _toDisplayString(item.title), 11, _hoisted_26))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createVNode(_component_SortingPanel, {
                items: _ctx.FILTERS,
                "query-sort": _ctx.selectedFilter,
                onSelect: _ctx.selectFilter
              }, null, 8, ["items", "query-sort", "onSelect"])
            ]),
            (_ctx.bonusTransactionStore.transactions.length)
              ? (_openBlock(), _createBlock(_component_HistoryScores, {
                  key: 0,
                  class: "history__list",
                  list: _ctx.bonusTransactionStore.transactions
                }, null, 8, ["list"]))
              : (_openBlock(), _createElementBlock("span", _hoisted_28, "У вас еще нет бонусных баллов")),
            (
            _ctx.bonusTransactionStore.transactions.length &&
            _ctx.page !== _ctx.bonusTransactionStore.totalPages &&
            _ctx.bonusTransactionStore.totalPages
          )
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  _createElementVNode("div", {
                    class: "history__show-more",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showMore && _ctx.showMore(...args)))
                  }, " Показать еще ")
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}